import { IConditionalValue } from "@/components/Form/ComplexConditionalField";
import { RichTextValue } from "@/components/Form/RichTextField";

type FieldTransformer = (
  value: any,
  oldName: string,
  newName: string,
  nodeId: string,
  fieldKey: string
) => any;

const transformRichTextField: FieldTransformer = (value, oldName, newName) => {
  if (!value) return value;

  const transformRichText = (richText: RichTextValue): RichTextValue => {
    if (!richText.text || !richText.definition) return richText;
    return {
      text: richText.text.replace(`((${oldName}))`, `((${newName}))`),
      definition: {
        ...richText.definition,
        content: richText.definition.content.map((item: any) => {
          if (!item.content) return item;
          return {
            ...item,
            content: item.content.map((contentItem: any) => {
              if (
                contentItem.type === "mention" &&
                contentItem.attrs.id === oldName
              ) {
                return {
                  ...contentItem,
                  attrs: {
                    ...contentItem.attrs,
                    id: newName,
                  },
                };
              }
              return contentItem;
            }),
          };
        }),
      },
    };
  };

  if (Array.isArray(value)) {
    return value.map((richValue) => transformRichText(richValue));
  } else {
    return transformRichText(value);
  }
};

const transformComplexConditionalField: FieldTransformer = (
  value,
  oldName,
  newName
) => {
  if (!value || !Array.isArray(value)) return value;

  return value.map((conditionalValue: IConditionalValue) => {
    const updatedValue: IConditionalValue = { ...conditionalValue };
    const field_value =
      typeof updatedValue.regular_condition?.field === "string"
        ? updatedValue.regular_condition?.field
        : updatedValue.regular_condition?.field?.value;

    if (field_value && field_value === oldName) {
      updatedValue.regular_condition = {
        ...updatedValue.regular_condition,
        field: { label: newName, value: newName },
      } as IConditionalValue["regular_condition"];
    }

    if (updatedValue.ai_condition?.prompt) {
      updatedValue.ai_condition = {
        ...updatedValue.ai_condition,
        prompt: transformRichTextField(
          updatedValue.ai_condition.prompt,
          oldName,
          newName,
          "",
          ""
        ),
      };
    }

    return updatedValue;
  });
};
const transformDictComplexListField: FieldTransformer = (
  value,
  oldName,
  newName
) => {
  const new_value = value.map((item: any) => {
    return {
      ...item,
      Condition: transformRichTextField(
        item.Condition,
        oldName,
        newName,
        "",
        ""
      ),
      Output: transformRichTextField(item.Output, oldName, newName, "", ""),
    };
  });

  return new_value;
};

export const fieldTransformers: Record<string, FieldTransformer> = {
  big_text_variables: transformRichTextField,
  rich_text_variables: transformRichTextField,
  rich_text_variables_ai: transformRichTextField,
  config_complex_condition: transformComplexConditionalField,
  config_dict_complex_list: transformDictComplexListField,
};
